export default "__VITE_ASSET__Bbf7AAD7__"